import React from 'react';
import classnames from "classnames";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from "react-localize-redux";
import { JumpingBeans } from './loadingComponent';
import { popupActions } from '../../store/popupStore';
import { reportActions, SECTIONS } from '../../store/reportStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import Message from './message';
import BbCollapse from './BbCollapse';

import Alerts from '../reportSections/alerts';
import AmlInfoCheck from '../reportSections/amlInfoCheck';
import BasicInfo from '../reportSections/basicInfo';
import CompanyInDifficultySection from '../reportSections/companyInDifficultySection';
import ContactData from '../reportSections/contactData';
import EconomicGroupData from '../reportSections/economicGroup/economicGroupData';
import EconomicGroupEvaluation from '../reportSections/economicGroup/economicGroupEvaluation';
import EconomicGroupFinalOwners from '../reportSections/economicGroup/economicGroupFinalOwners';
import EconomicGroupSme from '../reportSections/economicGroup/economicGroupSme';
import ESGSection from '../reportSections/esgSection';
import FinRatiosData from '../reportSections/finRatiosData';
import FinStatementsData from '../reportSections/finStatementsData';
import GeneralAssembliesData from '../reportSections/generalAssembliesData';
import GrantsData from '../reportSections/grantsData';
import IdentData from '../reportSections/identData';
import IndustryRegionData from '../reportSections/industryRegionData';
import ITrade from '../reportSections/iTrade';
import Liens from '../reportSections/liens';
import ListOfVehicles from '../reportSections/listOfVehicles/listOfVehicles';
import MirriIdentData from '../reportSections/mirriIdentData';
import MirriPersonalRelations from '../reportSections/mirriPersonalRelationsData';
import MirriRatingData from '../reportSections/mirriRatingData';
import MonitoraAnnotations from '../reportSections/monitoraSections/monitoraAnnotations';
import NaturalIdentData from '../reportSections/naturalPersonSections/naturalIdentData';
import OrsrDataRecap from '../reportSections/orsrDataRecap';
import ProcurementData from "../reportSections/procurementData";
import PublicContracts from '../reportSections/publicContracts';
import QuickAddressReport from '../reportSections/quickReportSections/quickAddressReport';
import QuickAddressReportRelations from '../reportSections/quickReportSections/quickAddressReportRelations';
import QuickReport from '../reportSections/quickReportSections/quickReport';
import QuickReportFinDataUpdate from '../reportSections/quickReportSections/quickReportFinDataUpdate';
import QuickReportFinStatementsInfo from '../reportSections/quickReportSections/quickReportFinStatementsInfo';
import QuickReportMonitoraTeaser from '../reportSections/quickReportSections/quickReportMonitoraTeaser';
import QuickReportRelations from '../reportSections/quickReportSections/quickReportRelations';
import RatingData from '../reportSections/ratingData';
import Recievables from '../reportSections/recievables/recievablesData';
import RegisteredVehicles from '../reportSections/registeredVehicles/registeredVehiclesData';
import RelationsCRSRData from '../reportSections/relationsCRSRData';
import RelationsData from '../reportSections/relationsData';
import RelationSubSection from '../reportSections/relations/relationSubSection';
import ReliabilityAML from '../reportSections/reliability/reliabilityAML/reliabilityAmlCheck';
import ReliabilityCEE from '../reportSections/reliability/reliabilityCEE';
import ReliabilityData from '../reportSections/reliability/reliabilityData';
import RepiTeaser from '../reportSections/repiTeaser';
import SubjectActivity from '../reportSections/activity/subjectActivity';
import WarningData from '../reportSections/warningData';
import ESGDataSources from '../reportSections/esg/esgDataSources';
import ESGIdentData from '../reportSections/esg/esgIdentData';
import ESGMethodology from '../reportSections/esg/esgMethodology';
import ESGScoreOverview from '../reportSections/esg/esgScoreOverview';
import ESGScoreSection from '../reportSections/esg/esgScoreSection';
import ESGSubfactorSection from '../reportSections/esg/esgSubfactorSection';

// Repi
import Identification from '../repi/repiSections/identification';
import ContactHistory from '../repi/repiSections/contactHistory';
import PaymentHistory from '../repi/repiSections/paymentHistory';
import PaymentHistoryDataCorrection from '../repi/repiSections/paymentHistoryDataCorrection';
import SubjectDataCorrection from '../repi/repiSections/subjectDataCorrection';
import RepiITrade from '../repi/repiSections/invoices/repiITrade';

import AngleDownIcon from '../../img/icons/BBiconsRozbalit';
import SvgRefresh from "../../img/icons/Refresh";

import "./reportSection.scss";
import '../reportSections/rating/ratingCard.scss';

class ReportSection extends React.Component {
    constructor(props) {
        super(props);

        this.tagName = this.knownSections[this.props.sectionId] || this.knownSections["empty"];
    }

    knownSections = {
        "empty": () => (""),
        [SECTIONS.identData]: IdentData,
        [SECTIONS.mirriIdentData]: MirriIdentData,
        [SECTIONS.contactData]: ContactData,
        [SECTIONS.ratingData]: RatingData,
        [SECTIONS.warningData]: WarningData,
        [SECTIONS.mirriWarningData]: WarningData,
        [SECTIONS.finStatementsData]: FinStatementsData,
        [SECTIONS.finRatiosData]: FinRatiosData,
        [SECTIONS.subjectActivity]: SubjectActivity,
        [SECTIONS.amlInfoCheck]: AmlInfoCheck,
        [SECTIONS.industryRegionData]: IndustryRegionData,
        [SECTIONS.grantsData]: GrantsData,
        [SECTIONS.mirriGrantsData]: GrantsData,
        [SECTIONS.basicInfo]: BasicInfo,
        [SECTIONS.iTrade]: ITrade,
        [SECTIONS.relationsData]: RelationsData,
        [SECTIONS.relatedAddresses]: RelationSubSection,
        [SECTIONS.publicContracts]: PublicContracts,
        [SECTIONS.generalAssembliesData]: GeneralAssembliesData,
        [SECTIONS.publicProcurements]: ProcurementData,
        [SECTIONS.liens]: Liens,
        [SECTIONS.alerts]: Alerts,
        [SECTIONS.naturalIdentData]: NaturalIdentData,
        [SECTIONS.quickReport]: QuickReport,
        [SECTIONS.quickReportRelations]: QuickReportRelations,
        [SECTIONS.quickReportFinStatementsInfo]: QuickReportFinStatementsInfo,
        [SECTIONS.quickReportFinDataUpdate]: QuickReportFinDataUpdate,
        [SECTIONS.quickAddressReport]: QuickAddressReport,
        [SECTIONS.quickAddressReportRelations]: QuickAddressReportRelations,
        [SECTIONS.monitoraTeaser]: QuickReportMonitoraTeaser,
        [SECTIONS.economicGroupData]: EconomicGroupData,
        [SECTIONS.essFinalOwners]: EconomicGroupFinalOwners,
        [SECTIONS.economicGroupSme]: EconomicGroupSme,
        [SECTIONS.economicGroupEvaluation]: EconomicGroupEvaluation,
        [SECTIONS.shortReport]: IdentData,
        [SECTIONS.shortReportRatingData]: RatingData,
        [SECTIONS.shortReportWarningData]: WarningData,
        [SECTIONS.shortReportRelationsCRSRData]: RelationsCRSRData,
        [SECTIONS.shortReportRelationsData]: RelationsData,
        [SECTIONS.shortReportBasicInfo]: BasicInfo,
        [SECTIONS.shortReportITrade]: ITrade,
        [SECTIONS.monitoraAnnotation]: MonitoraAnnotations,
        [SECTIONS.registeredVehicles]: RegisteredVehicles,
        [SECTIONS.warningsReport]: IdentData,
        [SECTIONS.warningsReportWarningData]: WarningData,
        [SECTIONS.recievables]: Recievables,
        [SECTIONS.listOfVehicles]: ListOfVehicles,
        [SECTIONS.vehiclesOverview]: RegisteredVehicles,
        [SECTIONS.reliabilityReport]: ReliabilityData,
        [SECTIONS.reliabilityCEE]: ReliabilityCEE,
        [SECTIONS.reliabilityAML]: ReliabilityAML,
        [SECTIONS.relationsCRSRData]: RelationsCRSRData,
        [SECTIONS.shortReportRepiTeaser]: RepiTeaser,
        [SECTIONS.repiTeaser]: RepiTeaser,
        [SECTIONS.repiReportIdentification]: Identification,
        [SECTIONS.repiReportContactHistory]: ContactHistory,
        [SECTIONS.repiReportPaymentHistory]: PaymentHistory,
        [SECTIONS.repiPaymentHistoryDataCorrection]: PaymentHistoryDataCorrection,
        [SECTIONS.repiSubjectDataCorrection]: SubjectDataCorrection,
        [SECTIONS.repiITrade]: RepiITrade,
        [SECTIONS.mirriRatingData]: MirriRatingData,
        [SECTIONS.mirriPublicContracts]: PublicContracts,
        [SECTIONS.mirriORSRDataRecap]: OrsrDataRecap,
        [SECTIONS.mirriPersonalRelations]: MirriPersonalRelations,
        [SECTIONS.mirriRelationsData]: RelationsData,
        [SECTIONS.esg]: ESGSection,
        [SECTIONS.companyInDifficulty]: CompanyInDifficultySection,
        [SECTIONS.esgIdentData]: ESGIdentData,
        [SECTIONS.esgScoreOverview]: ESGScoreOverview,
        [SECTIONS.esgScoreDetail]: ESGScoreSection,
        [SECTIONS.esgScoreE]: ESGScoreSection,
        [SECTIONS.esgSubfactorsE]: ESGSubfactorSection,
        [SECTIONS.esgScoreS]: ESGScoreSection,
        [SECTIONS.esgSubfactorsS]: ESGSubfactorSection,
        [SECTIONS.esgScoreG]: ESGScoreSection,
        [SECTIONS.esgSubfactorsG]: ESGSubfactorSection,
        [SECTIONS.esgMethodology]: ESGMethodology,
        [SECTIONS.esgDataSources]: ESGDataSources,
        [SECTIONS.esgReporting]: ESGSection,
    };

    headerStyles = {
        'round': "circle",
        'square': ""
    };

    state = {
        reportHeaderStyle: 'square',
        dataHash: undefined
    }

    componentDidMount() {
        this.props.attachSectionElement(this.props.sectionId, this.holder);
        this.props.loadIfExpanded(this.props.sectionId);
        this.setState({ reportHeaderStyle: localStorage.locales_report_headers_style });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.report.isExpandAllActivated !== this.props.report.isExpandAllActivated && this.props.report.isExpandAllActivated) {
            this.props.loadIfExpanded(this.props.sectionId);
        }
    }

    getNextSection = () => {
        var nextId = this.props.report.sections.find(o => o.id === this.props.sectionId).orderId;
        return this.props.report.sections.find(o => o.orderId > nextId && !o.hidden);
    }
    scrollToNextSection = () => {
        var nextSection = this.getNextSection();
        if (nextSection !== undefined)
            this.props.report.elements[nextSection.id].scrollIntoView({ behavior: "smooth", block: 'start' });
    }

    static getDerivedStateFromError(error) {
        // Update state so next render shows fallback UI.
        return { error: error };
    }

    componentDidCatch(error, info) {
        // Log the error to an error reporting service
        console.log(error);
        console.log(info);
    }

    render() {
        if (isNullOrUndefined(this.props.report.sections))
            return null;

        if (this.state.error !== undefined)
            return this.renderUps();

        const TagName = this.tagName;
        const { name, data, dataHash, isLoading, expanded, isLimited, hasData, error, id, countryFilter } = this.props.report.sections.find(o => o.id === this.props.sectionId);
        const Icon = this.props.getSectionIcon(id);
        const showSectionHeader = isNullOrUndefined(this.props.showSectionHeader) || this.props.showSectionHeader === true;

        if (showSectionHeader) {
            return (
                <div id={this.props.sectionId} data-level={1} className={classnames({ 'report-section': true, 'is-expanded': expanded && !isNullOrUndefined(data), 'info-na': !hasData })}
                    ref={(el) => this.holder = el} style={{ pointerEvents: hasData ? "auto" : "none" }}>
                    <div
                        className={classnames("header-wrap", { 'header-wrap-circle-icon': this.state.reportHeaderStyle === 'round', 'info-na': !hasData })}
                        style={{ cursor: hasData ? "pointer" : "not-allowed" }}
                        onClick={e => !e.isDefaultPrevented() && this.props.toggleSection([this.props.sectionId], !expanded, isLimited)}
                    >
                        <div
                            ref={el => this.iconWrapper = el ? el : this.iconWrapper}
                            className={`${classnames(this.headerStyles[this.state.reportHeaderStyle])} top-left with-icon`}
                        >
                            <Icon fill='#fff' />
                        </div>
                        <div className={classnames("header-body", { 'info-na': !hasData })} >
                            <div className="name">{countryFilter ? <span>{name} <sup>{countryFilter}</sup></span> : name}</div>
                            {isLoading && <JumpingBeans />}

                            {this.renderRight(id, expanded, data, hasData)}
                        </div>

                    </div>

                    {hasData && !isLoading &&
                        <BbCollapse className="report-section-body" tag="div" isOpen={(!isNullOrUndefined(data) || !isNullOrUndefined(error)) && expanded}>
                            {error ?
                                <div className="error-container error-container-wide" style={{ padding: "0.7em 1em 1em" }}>
                                    <Message type='warning' message={<Translate id={error} options={{ renderInnerHtml: true }} />} shadowed={true} />
                                </div> :
                                <TagName sectionId={this.props.sectionId} data={data} isLimited={isLimited} dataHash={dataHash} id={this.props.report.id} reportType={this.props.report.reportType} />
                            }
                        </BbCollapse>
                    }
                </div>
            );
        } else {
            return (
                <div className="report-section-2 is-expanded" style={{ pointerEvents: hasData ? "auto" : "none" }}>
                    <div id={this.props.sectionId}>
                        {isLoading ? <div className="search-progress searching"></div> :
                            <div className="report-section-body">{error ?
                                <Message type='warning' message={<Translate id={error} options={{ renderInnerHtml: true }} />} /> :
                                <TagName sectionId={this.props.sectionId} />}
                            </div>
                        }
                    </div>
                </div>
            )
        }
    }

    renderUps = () => {
        const Icon = this.props.getSectionIcon(id);
        const { name, id } = this.props.report.sections.find(o => o.id === this.props.sectionId);
        return (
            <div id={this.props.sectionId} data-level={1} className='report-section is-expanded' ref={(el) => this.holder = el} style={{ pointerEvents: "auto" }}>
                <div className={classnames("header-wrap", { 'header-wrap-circle-icon': this.state.reportHeaderStyle === 'round' })} style={{ cursor: "pointer" }}>
                    <div ref={el => this.iconWrapper = el ? el : this.iconWrapper} className={`${classnames(this.headerStyles[this.state.reportHeaderStyle])} top-left with-icon`}>
                        <Icon fill='#fff' />
                    </div>
                    <div className='header-body' >
                        <div className="name">{name}</div>
                    </div>
                </div>

                <BbCollapse className="report-section-body" tag="div" isOpen={true}>
                    <div className="error-container error-container-wide" style={{ padding: "0.7em 0.1em" }}>
                        <Message type='warning' message={<Translate id='UnhappyUser.SectionRenderFailed' options={{ renderInnerHtml: true }} />} shadowed={true} />
                    </div>
                </BbCollapse>
            </div>
        );
    }

    renderRight = (id, expanded, data, hasData) => {
        if (hasData) {
            return (
                <div className="icon-wrap">
                    {this.props.refreshButton === true && !isNullOrUndefined(data) && <div
                        style={{ marginRight: "1em" }}
                        title={this.props.translate("Report.ReloadSection")}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.props.requestFetchSection([this.props.sectionId])
                        }
                        }>
                        <SvgRefresh

                            style={{ transition: 'all .5s ease', width: '1.4em', height: '1.4em' }}
                            className={classnames('svg-standard-fill', { 'print-hidden': !expanded })}
                        />
                    </div>}
                    <div>
                        <AngleDownIcon
                            style={{ transform: `scaleY(${expanded ? -1 : 1})`, transition: 'all .5s ease', width: '1.4em', height: '1.4em' }}
                            className={classnames('svg-standard-fill', { 'print-hidden': !expanded })}
                        />
                    </div>
                </div>
            );
        }
        return (
            <div className="icon-wrap">
                <Translate id="Report.Common.SectionNoData" />
            </div>
        );
    }

    getSectionHelpComponentId = (sectionId) => {
        switch (sectionId) {
            case SECTIONS.ratingData: return 'ratingExplanatoryNotes';
            case SECTIONS.amlInfoCheck: return 'amlExplanatoryNotes';
            default: return null;
        }
    }
}

export default withLocalize(connect(
    state => ({ report: state.report, layout: state.layout }),
    dispatch => bindActionCreators(({ ...reportActions, ...popupActions }), dispatch)
)(ReportSection));